// function addBackgroundPhoto(id){
//   if(document.getElementById(`placeHolder-${id}`)){
//     window.addEventListener('scroll', function() {
//          document.querySelectorAll(`#${id} .data-background`).forEach( item => {
//      		let photoD = item.getAttribute('data-bg-d');
//      		let photoM = item.getAttribute('data-bg-m');
//      		if(screen.width > 767)
//        			item.style.backgroundImage="url(" + photoD +")";
//      		else
//        			item.style.backgroundImage="url(" + photoM +")";
//    			});
//     });
//   }
//   else{
//     document.querySelectorAll(`#${id} .data-background`).forEach( item => {
//      		let photoD = item.getAttribute('data-bg-d');
//      		let photoM = item.getAttribute('data-bg-m');
//      		if(screen.width > 767)
//        			item.style.backgroundImage="url(" + photoD +")";
//      		else
//        			item.style.backgroundImage="url(" + photoM +")";
//    	});
//   }
// }
// function  lazyloadContent(id,content){
//     var element = document.getElementById(`placeHolder-${id}`);
//   	if(document.getElementById(`placeHolder-${id}`)){
// 		var position = element.getBoundingClientRect();
//   		// checking for partial visibility
// 		if(position.top < window.innerHeight || position.bottom < window.innerHeight) {
//        		element.outerHTML = content;
//     	}
//   		else{
// 			window.addEventListener('scroll', function() {
//               	if(document.getElementById(`placeHolder-${id}`)){
// 				var position = element.getBoundingClientRect();
// 				// checking for partial visibility
// 				if(position.top < window.innerHeight || position.bottom < window.innerHeight) {
//               		element.outerHTML = content;
//                 }
//                 }
// 			});
//     	}
//     }
// }

//Method with IntersectionObserver

let prevRatio = 0;
let elements, id;

window.addEventListener(
  "DOMContentLoaded",
  (event) => {
    elements = document.querySelectorAll(".placeholder");
    createObserver();
  },
  { once: true }
);

function createObserver() {
  let observer;

  let options = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: 0,
  };

  observer = new IntersectionObserver(handleIntersect, options);

  for (let i = 0; i < elements.length; i++) {
    if (elements[i].getAttribute("data-content")) {
      observer.observe(elements[i]);
    }
  }
}

function handleIntersect(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (entry.target.dataset.content.includes("data-background"))
        id = entry.target.id.replace("placeHolder-", "");

      if (entry.target.parentNode) { // check if element has parent node
          entry.target.outerHTML = entry.target.dataset.content;
          observer.unobserve(entry.target);
          assignBackgroundPhoto(id);
        }
    }

    prevRatio = entry.intersectionRatio;
  });
}

function assignBackgroundPhoto(id) {
  images = document.querySelectorAll(`#${id} .data-background`);
  images.forEach((item) => {
    let photoD = item.getAttribute("data-bg-d");
    let photoM = item.getAttribute("data-bg-m");
    if (screen.width > 767) item.style.backgroundImage = "url(" + photoD + ")";
    else item.style.backgroundImage = "url(" + photoM + ")";
  });
}
